import Vue from 'vue'
import Vuex from 'vuex'
import Login from './modules/login'
import General from './modules/general'
import Relatorio from './modules/relatorio'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        namespaced:true,
        Login,
        General,
        Relatorio
    }
})
